import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { NavLink, NavItem } from 'reactstrap';
import { NavLink as RRNavLink } from 'react-router-dom';

export function LoggedInNavItems(props) {
  const { handleLogout, navigated } = props;
  return (
    <Fragment>
      <NavItem>
        <NavLink tag={RRNavLink} to={'/Account/MyResults'} onClick={navigated}>
          My Results
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          className="locations"
          tag={RRNavLink}
          to={'/Account/MyAccount'}
          onClick={navigated}
        >
          My Account
        </NavLink>
      </NavItem>
      <NavItem>
        <NavLink
          className="nav-btn logout-btn"
          tag={RRNavLink}
          to={`/`}
          onClick={handleLogout}
        >
          LOGOUT OF MY ACCOUNT
        </NavLink>
      </NavItem>
    </Fragment>
  );
}
LoggedInNavItems.propTypes = {
  handleLogout: PropTypes.func.isRequired,
  navigated: PropTypes.func.isRequired,
};
